import * as React from 'react';
import IntersectionVisible from 'react-intersection-visible';
import debounce from 'lodash/debounce';

/**
 * Uses intersection observer API to determine if the element is visible within
 * viewport, and runs a debounced callback when visible. If the element is quickly
 * hidden again, the callback is cancelled.
 * 
 * NB: Edge has a bug where it will not trigger intersections for elements with 0 height.
 * 
 * @param param0 
 */
export const VisibilitySensor = ({onShow, wait=200, children}) => {
  const handleShow = debounce(onShow, wait, {leading:false, trailing:true});
  
  const cancelShow = ()=> {
    handleShow && handleShow.cancel();     
  };

  return <IntersectionVisible onShow={handleShow} onHide={cancelShow}>
    { children}
  </IntersectionVisible>;
};
